import { Link, useParams, useLocation } from "react-router-dom";
import { ArrowRight, CheckCircle2, Landmark, Building2, TrendingUp, Briefcase, Home as HomeIcon, Gem, Coins, Factory } from "lucide-react";
import { SERVICES } from "../mock";
import ContactForm from "../components/ContactForm";

const iconMap = { Landmark, Building2, TrendingUp, Briefcase, Home: HomeIcon, Gem, Coins, Factory };

export default function ServicePage() {
  const { slug } = useParams();
  const { pathname } = useLocation();
  const effectiveSlug = slug || (pathname.includes("trade-finance") ? "trade-finance" : "trade-finance");
  const service = SERVICES.find((s) => s.slug === effectiveSlug) || SERVICES[0];
  const Icon = iconMap[service.icon] || Landmark;

  return (
    <div>
      <section className="bg-gradient-to-br from-[#0a2540] to-[#1e40af] text-white py-16">
        <div className="container-x">
          <div className="text-xs uppercase tracking-[3px] opacity-80">Our Services</div>
          <h1 className="brand-serif text-4xl md:text-5xl font-extrabold mt-2">{service.title}</h1>
          <div className="text-sm mt-4 opacity-80">
            <Link to="/" className="hover:text-amber-300">Home</Link> / <span>{service.title}</span>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-x grid md:grid-cols-3 gap-10">
          <aside className="md:col-span-1 space-y-3">
            <div className="bg-[#eff6ff] rounded-xl p-5 border border-slate-100">
              <h4 className="text-[#0a2540] font-bold mb-3">All Services</h4>
              <ul className="space-y-1">
                {SERVICES.map((s) => (
                  <li key={s.slug}>
                    <Link to={`/services/${s.slug}`} className={`flex items-center justify-between px-3 py-2 rounded-lg text-sm ${s.slug === service.slug ? "bg-[#1e40af] text-white" : "hover:bg-white text-slate-700"}`}>
                      {s.title} <ArrowRight size={14} />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-[#0a2540] text-white rounded-xl p-6">
              <h4 className="font-bold text-lg">Need Help?</h4>
              <p className="text-sm opacity-80 mt-2">Talk to our finance consultants for tailored solutions.</p>
              <Link to="/contact" className="btn-primary mt-4 bg-white text-[#0a2540] hover:bg-amber-300">Contact Us <ArrowRight size={16} /></Link>
            </div>
          </aside>

          <div className="md:col-span-2">
            <div className="icon-badge w-16 h-16 mb-6"><Icon size={30} /></div>
            <h2 className="section-title">{service.short}</h2>
            <p className="text-slate-600 mt-5 leading-relaxed">{service.description}</p>
            <p className="text-slate-600 mt-4 leading-relaxed">
              At Fortunexis LLC, we structure {service.title.toLowerCase()} solutions that align with your business goals. Our experienced consultants handle documentation, negotiations with banking partners and post-issuance support so you can focus on operations.
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mt-8">
              {["Fast turnaround", "Global banking network", "Transparent fees", "End-to-end handling", "Regulatory compliance", "Dedicated relationship manager"].map((f) => (
                <div key={f} className="flex items-start gap-3 p-4 bg-[#eff6ff] rounded-lg">
                  <CheckCircle2 size={18} className="text-[#1e40af] mt-0.5" />
                  <span className="text-sm text-slate-700">{f}</span>
                </div>
              ))}
            </div>

            <div className="mt-10">
              <h3 className="text-[#0a2540] font-bold text-xl">Enquire about {service.title}</h3>
              <div className="mt-4"><ContactForm /></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
